import React from "react";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import { WEATHER_PROVIDER_LABELS, WEATHER_THRESHOLD_FIELDS } from "./systemConfigurationUtils";

const WeatherCronConfigPanel = ({ weatherCron, updateWeatherCron, updateWeatherProvider, updateWeatherThreshold }) => (
  <>
    <section className="system-config-panel">
      <div className="system-config-panel-head">
        <div>
          <h3>UAE weather and dust cron</h3>
          <p>Control cron state, provider selection, schedule interval, and dust classification thresholds.</p>
        </div>
      </div>

      <div className="system-config-weather-hero">
        <label className="system-config-switch-card">
          <span>
            <strong>Enable weather cron</strong>
            <small>When disabled, the cron worker skips UAE weather and dust sync.</small>
          </span>
          <input
            type="checkbox"
            checked={weatherCron.enabled !== false}
            onChange={(event) => updateWeatherCron({ enabled: event.target.checked })}
          />
        </label>

        <div className="system-config-editor-grid weather">
          <label>
            <span>Interval minutes</span>
            <input
              type="number"
              min="15"
              step="1"
              value={weatherCron.intervalMinutes}
              onChange={(event) => updateWeatherCron({ intervalMinutes: event.target.value })}
            />
          </label>
          <label>
            <span>Timeout ms</span>
            <input
              type="number"
              min="1000"
              step="500"
              value={weatherCron.requestTimeoutMs}
              onChange={(event) => updateWeatherCron({ requestTimeoutMs: event.target.value })}
            />
          </label>
          <label className="system-config-wide">
            <span>Timezone</span>
            <input
              value={weatherCron.timezone}
              onChange={(event) => updateWeatherCron({ timezone: event.target.value })}
              placeholder="Asia/Dubai"
            />
          </label>
        </div>
      </div>
    </section>

    <section className="system-config-panel">
      <div className="system-config-panel-head">
        <div>
          <h3>Weather providers</h3>
          <p>The cron stores every enabled provider response in the weather status audit payload.</p>
        </div>
      </div>

      <div className="system-config-provider-grid">
        {weatherCron.providers.map((provider) => (
          <label className={`system-config-provider-card ${provider.enabled !== false ? "enabled" : ""}`} key={provider.id}>
            <span className="system-config-provider-icon"><CloudQueueIcon /></span>
            <span>
              <strong>{WEATHER_PROVIDER_LABELS[provider.id] || provider.id}</strong>
              <small>{provider.role === "weather" ? "General weather verification" : "Air quality / dust source"}</small>
              {provider.apiKeyEnv ? <em>API key env: {provider.apiKeyEnv}</em> : null}
            </span>
            <input
              type="checkbox"
              checked={provider.enabled !== false}
              onChange={(event) => updateWeatherProvider(provider.id, { enabled: event.target.checked })}
            />
          </label>
        ))}
      </div>
    </section>

    <section className="system-config-panel">
      <div className="system-config-panel-head">
        <div>
          <h3>Dust thresholds</h3>
          <p>These values decide whether saved readings become clear, hazy, dusty, heavy dust, or sandstorm.</p>
        </div>
      </div>

      <div className="system-config-threshold-grid">
        {WEATHER_THRESHOLD_FIELDS.map((field) => (
          <label key={field.key}>
            <span>{field.label}</span>
            <input
              type="number"
              min="0"
              step={field.key === "hazyAerosolOpticalDepth" ? "0.01" : "1"}
              value={weatherCron.thresholds[field.key]}
              onChange={(event) => updateWeatherThreshold(field.key, event.target.value)}
            />
            <small>{field.unit}</small>
          </label>
        ))}
      </div>
    </section>
  </>
);

export default WeatherCronConfigPanel;
